import React, { useEffect, useRef, useState } from 'react';
import { makeAPI } from '../services/api';
import { useNavigate } from 'react-router-dom';

import $ from "jquery";
import "datatables.net";
import "datatables.net-dt";
import "datatables.net-dt/css/dataTables.dataTables.min.css";

import chess_icon from '/src/assets/img/lb_icons/chess.png';
import mrracer_icon from '/src/assets/img/lb_icons/mrracer.png';
import xo_icon from '/src/assets/img/lb_icons/xo.png';
import cr_icon from '/src/assets/img/lb_icons/cr.png';
import coin from '/src/assets/img/icons/coin.avif';

import sponsor_banner from '/src/assets/img/lb_sponsor/sponsor.jpg';
import sponsor_banner_1 from '/src/assets/img/lb_sponsor/partner.jpg';
import sponsor_banner_2 from '/src/assets/img/lb_sponsor/sponsor2.jpg';

// Add new leaderboard game buttons here.
// Example:
// { id: 6, key: "newgame", label: "NEW GAME", icon: newgame_icon }
const LB_GAME_BUTTONS = [
  { id: 5, key: "mrracer", label: "MR RACER", icon: mrracer_icon },
  { id: 4, key: "tictactoe", label: "XO BLAST", icon: xo_icon },
  { id: 1, key: "chess", label: "CHESS.COM", icon: chess_icon },
  { id: 3, key: "clashroyale", label: "CLASH ROYALE", icon: cr_icon },
];

const LeaderBoard = () => {
  const user = localStorage.getItem('user');
  let token = JSON.parse(localStorage.getItem('user'));
  const user_id = token?.user_id;
  const defaultGameId = 5;
  const [toggle, settoggle] = useState('mrracer');
  const gamesStripRef = useRef(null);
  const navigate = useNavigate();
  const [GameId, setGameId] = useState(defaultGameId);
  const [EventId, setEventId] = useState(1);

  function scrollGameStrip(direction) {
    if (!gamesStripRef.current) return;
    const scrollAmount = 220;
    gamesStripRef.current.scrollBy({
      left: direction * scrollAmount,
      behavior: "smooth",
    });
  }

  useEffect(() => {
    document.title = "Leaderboard - CGES.CLUB";
    if ($.fn.DataTable.isDataTable('#leaderboard-data')) {
      $('#leaderboard-data').DataTable().destroy();
    }

    getLeaderboardList(defaultGameId);

    $(document).on("change", "#leaderboard-list", () => {
      LeaderboardData(defaultGameId);
    });

    return () => {
      $(document).off("change", "#leaderboard-list");
    };
  }, []);

  async function LeaderboardData(game_id) {
    enablePreloader();
    const inputObj = {
      event_id: $("#leaderboard-list").val() || 1,
      game_id: $('#leaderboard-list option:selected').attr('key') || game_id || 1,
    };

    setEventId(inputObj.event_id);
    setGameId(Number(inputObj.game_id));

    if ($.fn.DataTable.isDataTable('#leaderboard-data')) {
      $('#leaderboard-data').DataTable().clear().destroy();
      $('#leaderboard-data').empty();
    }

    $('#leaderboard-data').DataTable({
      stateSave: false,
      responsive: true,
      bInfo: false,
      bDestroy: true,
      bPaginate: false,
      ordering: false,
      serverSide: true,
      bAutoWidth: false,
      searching: false,
      lengthMenu: [10, 20, 30, 50],
      lengthChange: false,
      orderable: false,
      language: {
        emptyTable: "No data available",
      },
      ajax: {
        url: `${import.meta.env.VITE_API_URL}/api/leaderboard`,
        headers: { "x-api-key": import.meta.env.VITE_X_API_KEY },
        data: { inputObj, user_id },
        type: 'POST',
        dataType: 'json',
        error: function (xhr) {
          if (xhr.status === 429) {

            console.log("Too many requests");

            // Clear table safely
            const table = $('#leaderboard-data').DataTable();
            table.clear().draw();

            // Optional: Show message
            // $('#leaderboard-data tbody')
            //   .html('<tr><td colspan="10" class="text-center text-danger">Too many requests. Please wait.</td></tr>');
          }
        }
      },
      columns: columns_data(Number(inputObj.game_id)),
      columnDefs: Number(inputObj.game_id) === 2 || Number(inputObj.game_id) === 3
        ? [
            { className: "dt-head-left dt-body-left", targets: '_all' },
            { width: '10%', targets: 0 },
            { width: '35%', targets: 1 },
            { width: '10%', targets: 2 },
            { width: '10%', targets: 3 },
            { width: '10%', targets: 4 },
            { width: '15%', targets: 5 },
            { width: '10%', targets: 6 },
          ]
        : [
            { className: "dt-head-left dt-body-left", targets: '_all' },
            { width: '10%', targets: 0 },
            { width: '45%', targets: 1 },
            { width: '15%', targets: 2 },
            { width: '15%', targets: 3 },
            { width: '15%', targets: 4 },
          ],
      initComplete: function () {
        disablePreloader();
      },
      rowCallback: function (row, data) {
        // console.log("Row data:", data?.user_id, "User ID:", token?.user_id);
        $(row).removeClass('user-highlight');
        if (data.user_id === token?.user_id) {
          // console.log("Highlighting row for user:", data.player_name);
          $(row).addClass('user-highlight');
        }
      },
    });
  }

  async function getLeaderboardList(game_id) {
    $("#leaderboard-list").empty();
    try {
      const leaderboardList = await makeAPI("/api/leaderboard_list", "POST", false, { game_id });
      if (leaderboardList.status === "S") {
        if (leaderboardList.data.length > 0) {
          const current_event_id = leaderboardList.current_event;
          leaderboardList.data.forEach(item => {
            if (!$(`#leaderboard-list option[value='${item.event_id}']`).length) {
              const isSelected = item.event_id === current_event_id ? "selected" : "";
              $("#leaderboard-list").append(
                `<option key="${item.game_id}" value="${item.event_id}" ${isSelected}>${item.event_name}</option>`
              );
            }
            if (item.tour_status === 'live') {
              $("#leaderboard-list").val(item.event_id);
            }
          });
          LeaderboardData(game_id);
        } else {
          $("#leaderboard-list").append('<option value="">No Tournaments Available</option>');
          disablePreloader();
        }
      } else {
        $("#leaderboard-list").hide();
        LeaderboardData(game_id);
      }
    } catch (error) {
      disablePreloader();
      console.error("Error fetching leaderboard list:", error);
    }
  }

  return (
    <>
      <style>
        {`
        #leaderboard-data tbody tr.user-highlight > td {
          background-color: #ff810e !important;
          box-shadow: inset 0 0 0 9999px #ff810e !important;
          color: #fff !important;
          font-weight: 700 !important;
        }

        #leaderboard-data tbody tr.user-highlight > * {
          --bs-table-bg: #ff810e !important;
          --bs-table-striped-bg: #ff810e !important;
          --bs-table-accent-bg: #ff810e !important;
          --bs-table-color: #fff !important;
        }

        #leaderboard-data tbody tr.user-highlight:hover > td {
          background-color: #ff810e !important;
          box-shadow: inset 0 0 0 9999px #ff810e !important;
          color: #fff !important;
        }

        .lb-shell {
          --bg: #000000;
          --panel: #161616;
          --panel-2: #0a0a0a;
          --line: rgba(255, 255, 255, 0.09);
          --text: #f6f6f6;
          --muted: #b6b6b6;
          --accent: #ff810e;
          --accent-soft: rgba(255, 129, 14, 0.18);
          color: var(--text);
          position: relative;
          background:
            radial-gradient(circle at 12% 12%, rgba(255, 129, 14, 0.2), transparent 36%),
            radial-gradient(circle at 88% 5%, rgba(255, 129, 14, 0.14), transparent 26%),
            linear-gradient(155deg, #000000, #090909 45%, #161616 100%);
          border: 1px solid var(--line);
          border-radius: 26px;
          padding: 1.25rem;
          overflow: hidden;
          box-shadow: 0 22px 65px rgba(0, 0, 0, 0.52);
        }

        .lb-shell::before {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background-image:
            linear-gradient(transparent 97%, rgba(255,129,14,0.18) 100%),
            linear-gradient(90deg, transparent 97%, rgba(255,255,255,0.04) 100%);
          background-size: 28px 28px;
          opacity: 0.16;
        }

        .lb-heading {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          border: 1px solid var(--line);
          background: linear-gradient(120deg, rgba(255,129,14,.18), rgba(0,0,0,.8));
          border-radius: 18px;
          padding: .9rem 1rem;
          margin-bottom: 1rem;
        }

        .lb-title {
          margin: 0;
          font-size: clamp(1.2rem, 2.5vw, 2rem);
          letter-spacing: .1em;
          font-weight: 800;
          text-transform: uppercase;
        }

        .lb-status {
          font-size: .60rem;
          color: var(--muted);
          text-transform: uppercase;
          letter-spacing: .11em;
          border: 1px solid var(--line);
          padding: .35rem .7rem;
          border-radius: 999px;
          background: rgba(0, 0, 0, 0.78);
        }

        .lb-games-wrap {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          gap: .55rem;
          margin-bottom: 1rem;
        }

        .lb-games-nav {
          flex: 0 0 38px;
          height: 38px;
          border-radius: 50%;
          border: 1px solid rgba(255,255,255,.2);
          background: linear-gradient(180deg, #1f1f1f, #101010);
          color: #ffb066;
          font-weight: 800;
          font-size: 1rem;
          line-height: 1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: border-color .2s ease, transform .2s ease;
        }

        .lb-games-nav:hover {
          border-color: rgba(255,129,14,.7);
          transform: translateY(-1px);
        }

        .lb-games {
          position: relative;
          display: grid;
          grid-auto-flow: column;
          grid-auto-columns: minmax(155px, 1fr);
          gap: .75rem;
          overflow-x: auto;
          overflow-y: hidden;
          scroll-behavior: smooth;
          scrollbar-width: none;
          width: 100%;
          padding: .15rem .1rem .35rem;
        }

        .lb-games::-webkit-scrollbar {
          display: none;
        }

        .lb-game-btn {
          border: 1px solid var(--line);
          background: linear-gradient(180deg, #1b1b1b, #0d0d0d);
          border-radius: 14px;
          padding: .7rem .55rem;
          color: var(--text);
          transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease;
          width: 100%;
        }

        .lb-game-btn:hover {
          transform: translateY(-2px);
          border-color: rgba(255,129,14,.7);
        }

        .lb-game-btn.active {
          border-color: var(--accent);
          box-shadow: 0 0 0 2px var(--accent-soft) inset, 0 0 20px rgba(255,129,14,.28);
        }

        .lb-game-icon {
          height: 52px;
          width: auto;
          object-fit: contain;
          margin-bottom: .4rem;
        }

        .lb-game-name {
          margin: 0;
          font-size: .78rem;
          letter-spacing: .04em;
          font-weight: 700;
          text-transform: uppercase;
          color: #f0f0f0;
          line-height: 1.2;
        }

        .lb-main-grid {
          position: relative;
          z-index: 2;
          display: grid;
          grid-template-columns: minmax(0, 1fr) 280px;
          gap: 1rem;
        }

        .lb-panel {
          border: 1px solid var(--line);
          background: linear-gradient(180deg, #161616, #0a0a0a);
          border-radius: 18px;
          padding: .9rem;
          overflow: hidden;
        }

        .lb-controls {
          display: flex;
          flex-wrap: wrap;
          gap: .75rem;
          align-items: center;
          justify-content: space-between;
          margin-bottom: .85rem;
        }

        .lb-controls .ui-dropdown {
          min-width: 220px;
          flex: 1;
          position: relative;
        }

        #leaderboard-list {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          min-height: 42px;
          border-radius: 10px;
          border: 1px solid rgba(255,255,255,.18);
          background: #161616;
          color: #fff;
          padding-right: 2.2rem;
        }

        #leaderboard-list:focus,
        #leaderboard-list:active {
          border-color: var(--accent) !important;
          box-shadow: 0 0 0 .2rem rgba(255, 129, 14, 0.2) !important;
        }

        .dropdown-arrow {
          position: absolute;
          right: .95rem;
          top: 50%;
          transform: translateY(-50%);
          color: #bfbfbf;
          pointer-events: none;
        }

        .lb-play-btn {
          min-width: 130px;
          border: 0;
          border-radius: 10px;
          background: linear-gradient(180deg, #ff9f3f, #ff810e);
          color: #fff;
          font-weight: 700;
          letter-spacing: .05em;
          text-transform: uppercase;
          height: 42px;
          padding: 0 1rem;
          box-shadow: 0 8px 22px rgba(255,129,14,.35);
        }

        .lb-sponsor {
          border: 1px solid var(--line);
          border-radius: 14px;
          padding: .85rem;
          background:
            linear-gradient(155deg, rgba(255,129,14,.16), rgba(255,129,14,.05) 40%, rgba(0,0,0,.9) 100%),
            linear-gradient(180deg, #161616, #0a0a0a);
          margin-bottom: .75rem;
        }

        .lb-sponsor-media {
          position: relative;
          border-radius: 10px;
          overflow: hidden;
          margin-bottom: .7rem;
          border: 1px solid rgba(255,255,255,.12);
          min-height: 110px;
          background: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }

        .lb-sponsor-media--hero {
          // aspect-ratio: 1200 / 320;
          min-height: 140px;
        }

        .lb-sponsor-media--side {
          aspect-ratio: 320 / 180;
        }

        .lb-sponsor-media--mobile {
          aspect-ratio: 1200 / 320;
        }

        .lb-sponsor-media::after {
          content: none;
          position: absolute;
          inset: 0;
          pointer-events: none;
        }

        .lb-sponsor-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
          display: block;
        }

        .lb-sponsor-media-label {
          position: absolute;
          bottom: .45rem;
          left: .55rem;
          z-index: 2;
          font-size: .68rem;
          text-transform: uppercase;
          letter-spacing: .1em;
          color: #fff;
          background: rgba(255,129,14,.82);
          border: 1px solid rgba(255,255,255,.22);
          border-radius: 999px;
          padding: .18rem .52rem;
        }

        .lb-sponsor-tag {
          color: #ffb066;
          font-size: .68rem;
          letter-spacing: .1em;
          text-transform: uppercase;
          margin-bottom: .45rem;
          display: block;
        }

        .lb-sponsor-title {
          margin: 0 0 .25rem;
          font-size: 1rem;
          font-weight: 700;
        }

        .lb-sponsor-copy {
          margin: 0;
          color: #d8d8d8;
          font-size: .84rem;
          line-height: 1.35;
        }

        .lb-sponsor-cta {
          margin-top: .65rem;
          display: inline-block;
          font-size: .78rem;
          color: #fff;
          background: rgba(255,129,14,.2);
          border: 1px solid rgba(255,129,14,.45);
          border-radius: 999px;
          padding: .25rem .6rem;
        }

        .lb-mobile-ad {
          display: none;
          margin-top: .8rem;
        }

        .lb-panel .dataTables_wrapper {
          color: #f0f0f0;
          background: #111111;
          border: 1px solid rgba(255,255,255,.08);
          border-radius: 14px;
          padding: .55rem .55rem .35rem;
        }

        .lb-panel .dataTables_wrapper .dataTables_processing {
          background: #161616;
          border: 1px solid rgba(255,129,14,.45);
          border-radius: 10px;
          color: #fff;
        }

        .lb-panel .dataTables_wrapper .dataTables_empty {
          color: #cfcfcf;
          padding: 1rem !important;
          text-align: center;
        }

        .lb-panel .dataTables_wrapper .dataTables_scroll {
          border-radius: 10px;
          overflow: hidden;
        }

        .lb-panel .dataTables_wrapper table.dataTable.no-footer {
          border-bottom: 1px solid rgba(255,255,255,.08);
        }

        #leaderboard-data,
        #leaderboard-data thead th,
        #leaderboard-data tbody td,
        #leaderboard-data tbody tr,
        table.dataTable.table-striped > tbody > tr:nth-of-type(odd) > * {
          background-color: #161616 !important;
          color: #f0f0f0 !important;
          border-color: rgba(255,255,255,.08) !important;
        }

        #leaderboard-data thead th {
          color: #ffb066 !important;
          text-transform: uppercase;
          letter-spacing: .05em;
          font-size: .78rem;
          border-bottom: 1px solid rgba(255,129,14,.25) !important;
          background: linear-gradient(180deg, #191919, #141414) !important;
          padding: .85rem .75rem !important;
        }

        #leaderboard-data tbody td {
          padding: .8rem .75rem !important;
          vertical-align: middle !important;
          transition: background-color .2s ease, color .2s ease;
        }

        #leaderboard-data tbody tr:hover td {
          background: rgba(255,129,14,.12) !important;
        }

        #leaderboard-data tbody tr {
          border-bottom: 1px solid rgba(255,255,255,.06);
        }

        .lb-panel .dataTables_wrapper .dataTables_paginate .paginate_button {
          color: #eee !important;
          border: 1px solid rgba(255,255,255,.18) !important;
          background: #1a1a1a !important;
          border-radius: 7px;
          margin: 0 .15rem;
        }

        .lb-panel .dataTables_wrapper .dataTables_paginate .paginate_button.current,
        .lb-panel .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
          color: #fff !important;
          border-color: rgba(255,129,14,.7) !important;
          background: rgba(255,129,14,.28) !important;
        }

        .lb-panel .dataTables_wrapper .dataTables_info,
        .lb-panel .dataTables_wrapper .dataTables_length label,
        .lb-panel .dataTables_wrapper .dataTables_filter label {
          color: #bdbdbd !important;
          font-size: .82rem;
        }

        #leaderboard-data_wrapper .child {
          background: #141414 !important;
        }

        #leaderboard-data_wrapper .child ul.dtr-details {
          width: 100%;
        }

        #leaderboard-data_wrapper .child ul.dtr-details li {
          border-bottom: 1px solid rgba(255,255,255,.08);
          padding: .45rem .2rem;
        }

        #leaderboard-data_wrapper .child ul.dtr-details span.dtr-title {
          color: #ffb066;
        }

        #leaderboard-data_wrapper .child ul.dtr-details span.dtr-data {
          color: #f1f1f1;
        }

        @media (max-width: 991px) {
          .lb-main-grid {
            grid-template-columns: minmax(0, 1fr);
          }

          .lb-sidebar {
            display: none;
          }

          .lb-mobile-ad {
            display: block;
          }
        }

        @media (max-width: 767px) {
          .lb-shell {
            padding: .9rem;
            border-radius: 18px;
          }

          .lb-games {
            gap: .6rem;
            grid-auto-columns: minmax(135px, 1fr);
          }

          .lb-game-btn {
            padding: .65rem .5rem;
          }

          .lb-game-icon {
            height: 42px;
          }

          .lb-controls .ui-dropdown {
            min-width: 100%;
          }

          .lb-play-btn {
            width: 100%;
          }

          .lb-games-nav {
            flex-basis: 34px;
            height: 34px;
            font-size: .92rem;
          }

          .lb-sponsor-media {
            min-height: 96px;
          }

          .lb-sponsor-media--hero,
          .lb-sponsor-media--mobile {
            min-height: 92px;
          }
        }
      `}
      </style>

      <div className="container pd-top-120">
        <div className="lb-shell">
          <div className="lb-heading">
            <h3 className="lb-title">LEADERBOARD</h3>
            <span className="lb-status">Live Rankings</span>
          </div>

          {/* <div className="lb-sponsor">
            <div className="lb-sponsor-media lb-sponsor-media--hero">
              <img src={sponsor_banner} alt="Sponsored travel campaign" className="lb-sponsor-img" />
              <span className="lb-sponsor-media-label">Sponsored</span>
            </div>
            <span className="lb-sponsor-tag">Sponsored</span>
            <h4 className="lb-sponsor-title">Fly, Compete, Win More</h4>
            <p className="lb-sponsor-copy">
              Esports travel packages and bootcamp stays for your next tournament destination.
            </p>
            <span className="lb-sponsor-cta">View Packages</span>
          </div> */}

          <div className="lb-games-wrap">
            <button
              type="button"
              className="lb-games-nav"
              aria-label="Scroll games left"
              onClick={() => scrollGameStrip(-1)}
            >
              &#8249;
            </button>
            <div className="lb-games" ref={gamesStripRef}>
              {LB_GAME_BUTTONS.map((game) => (
                <button
                  key={game.id}
                  type="button"
                  className={`lb-game-btn ${toggle === game.key ? "active" : ""}`}
                  onClick={() => {
                    enablePreloader();
                    leaderboard_selection(game.id, game.key, getLeaderboardList, settoggle);
                  }}
                >
                  <img src={game.icon} alt={game.label} className="lb-game-icon" />
                  <p className="lb-game-name">{game.label}</p>
                </button>
              ))}
            </div>
            <button
              type="button"
              className="lb-games-nav"
              aria-label="Scroll games right"
              onClick={() => scrollGameStrip(1)}
            >
              &#8250;
            </button>
          </div>

          <div className="lb-main-grid" style={{gridTemplateColumns:"none"}}>
            <div className="lb-panel">
              <div className="lb-controls">
                <div className="ui-dropdown">
                  <select className="form-control fs-6" id="leaderboard-list">
                    <option value="">Select Tournament</option>
                  </select>
                  <i className="fa fa-chevron-down dropdown-arrow" aria-hidden="true"></i>
                </div>
                <button
                  className="lb-play-btn"
                  onClick={() => navigate(`/tournaments/${GameId}/${EventId}`)}
                >
                  Play Now
                </button>
              </div>

              <div className="table-responsive">
                <table id="leaderboard-data" className="display table table-striped table-dark w-100">
                  <thead>
                    <tr></tr>
                  </thead>
                </table>
              </div>

              {/* <div className="lb-mobile-ad">
                <div className="lb-sponsor">
                  <div className="lb-sponsor-media lb-sponsor-media--mobile">
                    <img src={xo_icon} alt="Mobile sponsor placement" className="lb-sponsor-img" />
                    <span className="lb-sponsor-media-label">Featured</span>
                  </div>
                  <span className="lb-sponsor-tag">Sponsored</span>
                  <h4 className="lb-sponsor-title">Arena City Stays</h4>
                  <p className="lb-sponsor-copy">
                    Promote esports hotels, flights, or event city promotions for mobile viewers.
                  </p>
                  <span className="lb-sponsor-cta">Book Slot</span>
                </div>
              </div> */}
            </div>

            {/* <aside className="lb-sidebar">
              <div className="lb-sponsor">
                <div className="lb-sponsor-media lb-sponsor-media--side">
                  <img src={sponsor_banner_1} alt="Team transit campaign" className="lb-sponsor-img" />
                  <span className="lb-sponsor-media-label">Partner Ad</span>
                </div>
                <span className="lb-sponsor-tag">Sponsored</span>
                <h4 className="lb-sponsor-title">Game. Power. Lenovo.</h4>
                <p className="lb-sponsor-copy">
                  Performance built for competitive gaming and esports events. Reliable speed, bold innovation, and pro-level experiences.
                </p>
                <span className="lb-sponsor-cta">Learn More</span>
              </div>
              <div className="lb-sponsor">
                <div className="lb-sponsor-media lb-sponsor-media--side">
                  <img src={sponsor_banner_2} alt="Global LAN sponsor campaign" className="lb-sponsor-img" />
                  <span className="lb-sponsor-media-label">Top Deal</span>
                </div>
                <span className="lb-sponsor-tag">Sponsored</span>
                <h4 className="lb-sponsor-title">Gear. Play. Dominate</h4>
                <p className="lb-sponsor-copy">
                  Gaming accessories engineered for speed, precision, and comfort. Level up every match with immersive sound and control.
                </p>
                <span className="lb-sponsor-cta">Claim Offer</span>
              </div>
            </aside> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaderBoard;

function leaderboard_selection(id, key, getLeaderboardList, settoggle) {
  settoggle(key);
  getLeaderboardList(id);
}

function columns_data(game_id) {
  let columns;
  if (game_id === 1 || game_id === 4 || game_id === 5) {
    columns = [
      { data: 'rank', title: 'Rank', orderable: false },
      {
        data: 'player_name',
        title: 'Player Name',
        orderable: false,
        render: function (data) {
          return data === "Guest" ? "--" : data;
        }
      },
      {
        data: 'points',
        title: 'Points',
        orderable: false,
        render: function (points) {
          if (points >= 0) return points;
          if (points === "--") return "--";
          return 0;
        }
      },
      {
        data: 'reward',
        title: 'Reward <br/><small>(CGES coins)</small>',
        orderable: false,
        render: function (data) {
          const rewardPoints = data ? data : 0;
          return ` <img src="${coin}" loading="lazy" alt="Reward" width="15" height="15"> ${rewardPoints}`;
        },
      },
      {
        data: 'reward',
        title: 'MVP Points',
        orderable: false,
        render: function (data) {
          const rewardPoints = data ? data : 0;
          return `${rewardPoints}`;
        },
      }
    ];
  } else if (game_id === 2 || game_id === 3) {
    columns = [
      { data: 'rank', title: 'Rank', orderable: false },
      {
        data: 'player_name',
        title: 'Player Name',
        orderable: false,
        render: function (data) {
          return data === "Guest" ? "--" : data;
        }
      },
      {
        data: 'start_trophy',
        title: 'Initial Trophy',
        orderable: false,
        render: function (data) {
          return data === "--" ? "--" : data;
        }
      },
      {
        data: 'end_trophy',
        title: 'Final Trophy',
        orderable: false,
        render: function (data) {
          return data === "--" ? "--" : data;
        }
      },
      {
        data: 'points',
        title: 'Points',
        orderable: false,
        render: function (points) {
          if (points >= 0) return points;
          if (points === "--") return "--";
          return 0;
        }
      },
      {
        data: 'reward',
        title: 'Reward <br/><small>(CGES coins)</small>',
        orderable: false,
        render: function (data) {
          const rewardPoints = data ? data : 0;
          return `<img src="${coin}" loading="lazy" alt="Reward" width="15" height="15"> ${rewardPoints}`;
        },
      },
      {
        data: 'reward',
        title: 'MVP Points',
        orderable: false,
        render: function (data) {
          const rewardPoints = data ? data : 0;
          return `${rewardPoints}`;
        },
      }
    ];
  } else {
    columns = [
      { data: 'rank', title: 'Rank', orderable: false },
      { data: 'player_name', title: 'Player Name', orderable: false },
      { data: 'points', title: 'Points', orderable: false },
      { data: 'reward', title: 'Reward', orderable: false },
      { data: 'reward', title: 'MVP Points', orderable: false },
    ];
  }
  return columns;
}

function enablePreloader() {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.style.visibility = "visible";
    preloader.style.opacity = "1";
  }
}

function disablePreloader() {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.style.opacity = "0";
    setTimeout(() => {
      preloader.style.visibility = "hidden";
    }, 1000);
  }
}
